module.exports = __webpack_public_path__ + "static/media/album.35a89b33.png";